var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{attrs:{"options":_vm.options,"multiple":true,"flatten-search-results":true,"placeholder":"Select..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }